import { useTranslation } from "react-i18next";
import { Badge } from "@/shared/components/ui/badge";
import type { VenueStatus } from "./types";
import { venueStatusLabelKey, venueStatusVariant } from "./format-venue";

interface VenueStatusBadgeProps {
  readonly status: VenueStatus;
}

export function VenueStatusBadge({ status }: VenueStatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <Badge data-testid={`venue-status-${status}`} variant={venueStatusVariant(status)}>
      {t(venueStatusLabelKey(status))}
    </Badge>
  );
}
